"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footerStyles = exports.StyledTimeIcon = exports.StyledSwapIcon = exports.StyledRangeSeparator = exports.StyledRangePickerWrapper = exports.StyledRangePickerRangeArrow = exports.StyledRangePickerActiveBar = exports.StyledRangePicker = exports.StyledPickerSuffix = exports.StyledPickerPanels = exports.StyledPickerPanelWrapper = exports.StyledPickerPanelContainer = exports.StyledPickerPanel = exports.StyledPickerFooter = exports.StyledDatePickerInput = exports.StyledDatePicker = exports.StyledCustomIcon = exports.StyledClearIcon = exports.StyledCalendarIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _StyledTextInput = require("../TextInput/StyledTextInput");
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _excluded = ["children", "prefixCls", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledContainer = function StyledContainer(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return children(className.split(' ').pop());
};
var replacePx = function replacePx(string) {
  return parseInt(string.replace('px', ''));
};
var pickerCellInnerMixin = function pickerCellInnerMixin() {
  return (0, _ykbStyledComponents.css)(["&::before{position:absolute;top:50%;right:0;left:0;z-index:1;height:", ";transform:translateY(-50%);content:'';}[class$='-cell-inner']{position:relative;z-index:2;display:inline-block;min-width:", ";height:", ";line-height:", ";border-radius:", ";transition:background ", "s,border ", ";}&:hover:not([class*='-in-view']),&:hover:not([class*='-selected']):not([class*='-range-start']):not([class*='-range-end']):not([class*='-range-hover-start']):not([class*='-range-hover-end']){[class$='-cell-inner']{background:", ";}}&[class*='-in-view'][class*='-cell-today'] [class$='-cell-inner']:before{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;border:", " ", " ", ";border-radius:", ";content:'';}[class*='-in-range']{position:relative;&::before{background:", ";}}[class*='-in-view']{&[class*='-selected'],&[class*='-range-start'],&[class*='-range-end']{[class$='-cell-inner']{color:", ";background:", ";}}}[class*='-in-view'][class*='-range-start']:not([class*='-range-start-single']),[class*='-in-view'][class*='-range-end']:not([class*='-range-end-single']){&::before{background:", ";}}[class*='-in-view'][class-='-range-start']::before{left:50%;}[class*='-in-view'][class-='-range-end']::before{right:50%;}[class*='-range-hover-start']::after,[class*='-range-hover-end']::after,[class*='-range-hover']::after{right:0;left:2px;}[class*='-in-view'][class*='-in-range'][class*='-range-hover']::before,[class*='-in-view'][class*='-range-start'][class*='-range-hover']::before,[class*='-in-view'][class*='-range-end'][class*='-range-hover']::before,[class*='-in-view'][class*='-range-start']:not(&-range-start-single)[class*='-range-hover-start']::before,[class*='-in-view'][class*='-range-end']:not(&-range-end-single)[class*='-range-hover-end']::before{background:", ";}", "{>:not(&-date-panel)[class*='-in-view'][class*='-in-range'][class*='-range-hover-start']::before,>:not(&-date-panel)[class*='-in-view'][class*='-in-range'][class*='-range-hover-end']::before{background:", ";}&-date-panel [class*='-in-view'][class*='-in-range'][class*='-range-hover-start'],&-date-panel [class*='-in-view'][class*='-in-range'][class*='-range-hover-end']{[class$='-cell-inner']{&::after{position:absolute;top:0;bottom:0;z-index:-1;background:", ";content:'';}}}&-date-panel [class*='-in-view'][class*='-in-range'][class*='-range-hover-start']{[class$='-cell-inner']{&::after{right:-6px -", ";left:0px;}}}&-date-panel [class*='-in-view'][class*='-in-range'][class*='-range-hover-end']{[class$='-cell-inner']{&::after{left:-6px -", ";right:0px;}}}}[class*='-in-view'][class*='-range-start']:not([class*='-range-start-single']):not([class*='-range-end']) [class$='-cell-inner']{border-radius:", " 0 0 ", ";}[class*='-in-view'][class*='-range-end']:not([class*='-range-end-single']):not([class*='-range-start']) [class$='-cell-inner']{border-radius:0 ", " ", " 0;}[class*='-range-hover'][class*='-range-start']::after{right:50%;}[class*='-range-hover'][class*='-range-end']::after{left:50%;}tr > [class*='-in-view'][class*='-range-hover']:first-child::after,tr > [class*='-in-view'][class*='-range-hover-end']:first-child::after,[class*='-in-view'][class*='-range-hover-edge-start']:not(class*='-range-hover-edge-start-near-range')::after,[class*='-in-view'][class*='-range-hover-start']::after{left:6px;border-left:", " dashed ", ";border-top-left-radius:", ";border-bottom-left-radius:", ";}tr > [class*='-in-view'][class*='-range-hover']:last-child::after,tr > [class*='-in-view'][class*='-range-hover-start']:last-child::after,[class*='-in-view'][class*='-range-hover-edge-end']:not([class*='-range-hover-edge-end-near-range'])::after,[class*='-in-view'][class*='-range-hover-end']::after{right:6px;border-right:", " dashed ", ";border-top-right-radius:", ";border-bottom-right-radius:", ";}[class$='-disabled']{pointer-events:none;[class$='-cell-inner']{color:", ";background:transparent;}&::before{background:", ";}}[class$='-disabled'][class*='-today']{[class$='-cell-inner']{&::before{border-color:", ";}}}"], function (props) {
    return props.theme.datepicker.panelCellHeight;
  }, function (props) {
    return props.theme.datepicker.panelCellHeight;
  }, function (props) {
    return props.theme.datepicker.panelCellHeight;
  }, function (props) {
    return props.theme.datepicker.panelCellHeight;
  }, function (props) {
    return props.theme.borderRadiusBase;
  }, function (props) {
    return props.theme.animation.slow.duration;
  }, function (props) {
    return props.theme.animation.slow.duration;
  }, function (props) {
    return props.theme.datepicker.itemHoverBg;
  }, function (props) {
    return props.theme.border.width;
  }, function (props) {
    return props.theme.border.style;
  }, function (props) {
    return props.theme.color.primary6;
  }, function (props) {
    return props.theme.borderRadiusBase;
  }, function (props) {
    return props.theme.datepicker.cellActiveWithRangeColor;
  }, function (props) {
    return props.theme.datepicker.textColorInverse;
  }, function (props) {
    return props.theme.color.primary6;
  }, function (props) {
    return props.theme.datepicker.cellActiveWithRangeColor;
  }, function (props) {
    return props.theme.datepicker.itemHoverBg;
  }, StyledPickerPanelWrapper, function (props) {
    return props.theme.datepicker.itemHoverBg;
  }, function (props) {
    return props.theme.datepicker.itemHoverBg;
  }, function (props) {
    return props.theme.border.width;
  }, function (props) {
    return props.theme.border.width;
  }, function (props) {
    return props.theme.borderRadiusBase;
  }, function (props) {
    return props.theme.borderRadiusBase;
  }, function (props) {
    return props.theme.borderRadiusBase;
  }, function (props) {
    return props.theme.borderRadiusBase;
  }, function (props) {
    return props.theme.border.width;
  }, function (props) {
    return props.theme.datepicker.itemHoverBg;
  }, function (props) {
    return props.theme.borderRadiusBase;
  }, function (props) {
    return props.theme.borderRadiusBase;
  }, function (props) {
    return props.theme.border.width;
  }, function (props) {
    return props.theme.datepicker.itemHoverBg;
  }, function (props) {
    return props.theme.borderRadiusBase;
  }, function (props) {
    return props.theme.borderRadiusBase;
  }, function (props) {
    return props.theme.datepicker.disabledColor;
  }, function (props) {
    return props.theme.datepicker.disabledColor;
  }, function (props) {
    return props.theme.datepicker.disabledColor;
  });
};
var footerStyles = exports.footerStyles = function footerStyles() {
  return (0, _ykbStyledComponents.css)(["&-footer,&-picker-footer{background:#fff;}&-footer{width:min-content;min-width:100%;line-height:38px;text-align:center;border-bottom:", " ", " transparent;border-top:", " ", " ", ";&-extra{padding:0 ", ";line-height:38px;text-align:left;&:not(:last-child){border-bottom:", " ", " ", ";}}}&-ranges{margin:0;padding:10px 8px;overflow:hidden;line-height:20px;text-align:left;list-style:none;> li{display:inline-block;> a,button{&:disabled{cursor:not-allowed;}&:not(:disabled){&:hover{cursor:pointer;}}}}[class$='-ok']{float:right;margin-left:", ";button{background-color:#fff;border:none;color:", ";padding:0;}}}&-now{text-align:left;}&-today-btn{color:", ";&:hover{color:", ";cursor:pointer;}&:active{color:", ";}&-disabled{color:", ";cursor:not-allowed;}}"], function (props) {
    return props.theme.border.width;
  }, function (props) {
    return props.theme.border.style;
  }, function (props) {
    return props.theme.border.width;
  }, function (props) {
    return props.theme.border.style;
  }, function (props) {
    return props.theme.datepicker.borderColor;
  }, function (props) {
    return props.theme.datepicker.padding.sm;
  }, function (props) {
    return props.theme.border.width;
  }, function (props) {
    return props.theme.border.style;
  }, function (props) {
    return props.theme.datepicker.borderColor;
  }, function (props) {
    return props.theme.datepicker.padding.xs;
  }, function (props) {
    return props.theme.color.primary6;
  }, function (props) {
    return props.theme.datepicker.linkColor;
  }, function (props) {
    return props.theme.datepicker.linkHoverColor;
  }, function (props) {
    return props.theme.datepicker.linkActiveColor;
  }, function (props) {
    return props.theme.datepicker.disabledColor;
  });
};
var StyledRangeSeparator = exports.StyledRangeSeparator = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-16bggdk-0"
})(["align-items:center;margin:0 ", ";line-height:1;"], function (props) {
  return props.theme.datepicker.padding.sm;
});
var StyledPickerSuffix = exports.StyledPickerSuffix = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-16bggdk-1"
})(["align-self:center;margin-left:calc(", " / 2);color:", ";pointer-events:none;"], function (props) {
  return props.theme.datepicker.padding.xs;
}, function (props) {
  return props.theme.datepicker.disabledColor;
});
var StyledPickerPanels = exports.StyledPickerPanels = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-16bggdk-2"
})([""]);
var StyledPickerPanelWrapper = exports.StyledPickerPanelWrapper = (0, _ykbStyledComponents.default)(function (_ref2) {
  var children = _ref2.children,
    prefixCls = _ref2.prefixCls,
    className = _ref2.className,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(StyledPickerPanel, (0, _extends2.default)({
    prefixCls: prefix
  }, rest), children(prefix));
}).withConfig({
  componentId: "ykb-ui__sc-16bggdk-3"
})([""]);
var StyledPickerPanel = exports.StyledPickerPanel = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-16bggdk-4"
})([".", "{&-panel{display:inline-flex;flex-direction:column;text-align:center;background:", ";outline:none;}&-decade-panel,&-year-panel,&-quarter-panel,&-month-panel,&-week-panel,&-date-panel,&-time-panel{display:flex;flex-direction:column;width:", ";table{text-align:center;border-collapse:collapse;}}&-header{display:flex;padding:0 10px;color:", ";border-bottom:", " ", " ", ";> *{flex:none;}button{padding:0;color:", ";line-height:40px;background:transparent;border:0;cursor:pointer;transition:color ", ";}> button{min-width:1.6em;font-size:16px;font-weight:500;&:hover{color:", ";}}&-view{flex:auto;font-weight:500;line-height:40px;text-align:center;button{color:inherit;font-weight:500;&:not(:first-child){margin-left:", ";}&:hover{color:", ";}}}&-prev-icon,&-next-icon,&-super-prev-icon,&-super-next-icon{position:relative;display:inline-block;width:", ";height:", ";&::before{position:absolute;top:0;left:0;display:inline-block;width:", ";height:", ";border:0 solid currentColor;border-width:1.5px 0 0 1.5px;content:'';}}&-super-prev-icon,&-super-next-icon{&::after{position:absolute;", " display:inline-block;width:", ";height:", ";border:0 solid currentColor;border-width:1.5px 0 0 1.5px;content:'';}}&-prev-icon,&-super-prev-icon{transform:rotate(-45deg);}&-next-icon,&-super-next-icon{transform:rotate(135deg);}}&-content{width:100%;table-layout:fixed;border-collapse:collapse;th,td{position:relative;min-width:24px;font-weight:400;height:40px;}th{height:30px;color:", ";line-height:30px;}}&-cell{padding:3px 0;color:", ";cursor:pointer;&-in-view{color:", ";}&-disabled{cursor:not-allowed;color:", ";&:hover{background:transparent;[class$='-cell-inner']{background:transparent;}}[class$='-cell-inner']{cursor:not-allowed;&:hover,&:active{background:transparent !important;}}}&-in-range{color:", ";&:before{background:", ";}> [class*='-cell-inner']{background:", ";&:active{background:", ";}}&:hover{[class*='-cell-inner']{background:", ";}}&[class*='-range-hover-end'],&[class*='-range-hover']{&:before{background:", " !important;left:0px !important;}[class*='-cell-inner']{background:", ";}}&[class*='-range-hover-end']{&:before{width:100%;}}}&-range-hover{&:before{background:", ";}[class$='-cell-inner']{background:", ";}}&-inner{font-size:13px;box-sizing:border-box;padding:0;margin:0;background:transparent;cursor:pointer;outline:none;border:none;&:hover{background:", ";}&:active{background:", " !important;}}&-range-start > [class$='-cell-inner'],&-range-end > [class$='-cell-inner'],&-selected > [class$='-cell-inner']{background:", " !important;color:", ";}&-range-start,&-range-end{&:before{background:", ";}}&-range-hover-start,&-range-hover-end{&:before{background:", ";}[class$='-cell-inner']{background:", ";}}&-range-start{&[class*='-range-hover-start']{&:before{background:", ";}}}&-range-end{&[class*='-range-hover-end']{&:before{background:", ";}}}&-range-hover-start,&-range-start{&:before{left:10px !important;}}&-range-hover-end,&-range-end{&:before{width:32px;}}", ";}&-year-panel,&-month-panel{[class$='-cell-inner']{width:80px;}}&-decade-panel,&-year-panel,&-quarter-panel,&-month-panel{[class*='-content']{height:calc( ", " * 4 );}[class$='-cell-inner']{margin:0 ", ";}[class*='-cell']{[class*='-disabled'] [class$='-cell-inner']{background:", ";}}}&-quarter-panel{[class*='-content']{height:56px;}}", " &-decade-panel{[class$='-cell-inner']{padding:0 calc(", " / 2);}[class*='-cell']::before{display:none;}}&-year-panel,&-quarter-panel,&-month-panel{[class$='-body']{padding:0 ", ";}[class$='-cell-inner']{width:", ";}[class*='cell-range-hover-start']::after{left:calc( ( ", " - ", " * 2 ) / 3 - ", " );border-left:", " dashed ", ";border-radius:", " 0 0 ", ";}[class*='cell-range-hover-end']::after{right:calc( ( ", " - ", " * 2 ) / 3 - ", " );border-right:", " dashed ", ";border-radius:0 ", " ", " 0;}}&-week-panel{[class$='-body']{padding:", " ", ";}[class*='-cell']{&:hover [class$='-cell-inner'],[class*='-selected'] [class$='-cell-inner'],[class$='-cell-inner']{background:transparent !important;}}&-row{[class$='-cell-in-view']::before{transition:background ", ";}&:hover [class$='-cell-in-view']::before{background:", ";}&-selected td,&-selected:hover td{background:", " !important;&[class*='-cell-week']{color:", ";}&[class*='-cell-today'] [class$='-cell-inner']::before{border-color:", ";}[class$='-cell-inner']{color:", ";}}}[class$='-cell'],[class$='-cell-inner']{width:20px;}[class*='-cell-week']{font-size:12px;color:#999;font-weight:bold;}[class*='-cell']:hover > [class$='-cell-inner'],[class*='-cell-selected'] > [class$='-cell-inner']{background:transparent;}}&-date-panel{[class$='-body']{padding:", " ", ";}[class$='-content']{width:calc(", " * 7);th{width:", ";}}[class$='-cell-inner']{width:20px;}}&-datetime-panel{display:flex;[class$='-time-panel']{border-left:", " ", " ", ";}[class*='-date-panel'],[class*='-time-panel']{transition:opacity ", ";}&-active{[class*='-date-panel'],[class*='-time-panel']{opacity:0.3;&-active{opacity:1;}}}[class*='-time-panel-column']{&:after{height:calc( 294px - ", " + 2 * ", " );}}}&-time-panel{width:auto;min-width:auto;[class$='-content']{display:flex;flex:auto;max-height:278px;height:278px;}&-column{flex:none;text-align:left;list-style:none;margin:0;padding:0 0 180px 0;overflow-y:hidden;overflow-x:hidden;width:56px;transition:background 0.3s;font-size:12px;&::after{display:block;height:calc( 294px - ", " );content:'';}&:not(:first-child){border-left:", " ", " ", ";}&-active{background:", ";}&:hover{overflow-y:auto;}> li{margin:0;padding:0;cursor:pointer;&[class*='-time-panel-cell']{[class$='-time-panel-cell-inner']{display:block;width:100%;height:28px;margin:0;padding:0;color:", ";line-height:28px;text-align:center;border-radius:0;cursor:pointer;transition:background ", ";font-size:13px;&:hover{background:", ";}}&[class$='-selected']{[class$='-time-panel-cell-inner']{background:", ";}}&[class$='-disabled']{[class$='-time-panel-cell-inner']{color:", ";background:transparent;cursor:not-allowed;}}}}}}", " ", "}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.datepicker.calendarBg;
}, function (props) {
  return props.theme.datepicker.panelWidth;
}, function (props) {
  return props.theme.datepicker.panelHeadingColor;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.style;
}, function (props) {
  return props.theme.datepicker.borderColor;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.animation.slow.duration;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.datepicker.padding.xs;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.datepicker.panelArrowSize;
}, function (props) {
  return props.theme.datepicker.panelArrowSize;
}, function (props) {
  return props.theme.datepicker.panelArrowSize;
}, function (props) {
  return props.theme.datepicker.panelArrowSize;
}, function (props) {
  var size = Math.ceil(replacePx(props.theme.datepicker.panelArrowSize) / 2);
  return (0, _ykbStyledComponents.css)(["top:", "px;left:", "px;"], size, size);
}, function (props) {
  return props.theme.datepicker.panelArrowSize;
}, function (props) {
  return props.theme.datepicker.panelArrowSize;
}, function (props) {
  return props.theme.color.neutral11;
}, function (props) {
  return props.theme.color.neutral7;
}, function (props) {
  return props.theme.color.neutral11;
}, function (props) {
  return props.theme.datepicker.disabledColor;
}, function (props) {
  return props.theme.colorPalette.neutral1;
}, function (props) {
  return props.theme.color.primary5;
}, function (props) {
  return props.theme.color.primary5;
}, function (props) {
  return props.theme.colorPalette.grey2;
}, function (props) {
  return props.theme.colorPalette.grey1;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.colorPalette.grey1;
}, function (props) {
  return props.theme.colorPalette.grey1;
}, function (props) {
  return props.theme.colorPalette.grey1;
}, function (props) {
  return props.theme.colorPalette.grey2;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.neutral1;
}, function (props) {
  return props.theme.color.primary5;
}, function (props) {
  return props.theme.colorPalette.grey1;
}, function (props) {
  return props.theme.colorPalette.grey1;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary6;
}, pickerCellInnerMixin, function (props) {
  return props.theme.datepicker.panelWidthoutTimeCellHeight;
}, function (props) {
  return props.theme.datepicker.padding.sm;
}, function (props) {
  return props.theme.datepicker.disabledColor;
}, function (props) {
  return footerStyles();
}, function (props) {
  return props.theme.datepicker.padding.xs;
}, function (props) {
  return props.theme.datepicker.padding.xs;
}, function (props) {
  return props.theme.datepicker.panelYearMonthCellWidth;
}, function (props) {
  return props.theme.datepicker.panelWidth;
}, function (props) {
  return props.theme.datepicker.padding.xs;
}, function (props) {
  return props.theme.datepicker.panelYearMonthCellWidth;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.datepicker.itemHoverBg;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.datepicker.panelWidth;
}, function (props) {
  return props.theme.datepicker.padding.xs;
}, function (props) {
  return props.theme.datepicker.panelYearMonthCellWidth;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.datepicker.itemHoverBg;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.borderRadiusBase;
}, function (props) {
  return props.theme.datepicker.padding.xs;
}, function (props) {
  return props.theme.datepicker.padding.sm;
}, function (props) {
  return props.theme.animation.slow.duration;
}, function (props) {
  return props.theme.datepicker.itemHoverBg;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.neutral4;
}, function (props) {
  return props.theme.datepicker.textColorInverse;
}, function (props) {
  return props.theme.datepicker.textColorInverse;
}, function (props) {
  return props.theme.datepicker.padding.xs;
}, function (props) {
  return props.theme.datepicker.padding.sm;
}, function (props) {
  return props.theme.datepicker.panelCellWidth;
}, function (props) {
  return props.theme.datepicker.panelCellWidth;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.style;
}, function (props) {
  return props.theme.datepicker.borderColor;
}, function (props) {
  return props.theme.animation.slow.duration;
}, function (props) {
  return props.theme.datepicker.timePanelCellHeight;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.datepicker.timePanelCellHeight;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.style;
}, function (props) {
  return props.theme.datepicker.borderColor;
}, function (props) {
  return props.theme.datepicker.itemHoverBg;
}, function (props) {
  return props.theme.color.neutral11;
}, function (props) {
  return props.theme.animation.slow.duration;
}, function (props) {
  return props.theme.datepicker.itemHoverBg;
}, function (props) {
  return props.theme.colorPalette.blue2;
}, function (props) {
  return props.theme.datepicker.disabledColor;
}, function (props) {
  return props.$panelPosition === 'left' && (0, _ykbStyledComponents.css)(["&-body{padding-right:16px !important;}"]);
}, function (props) {
  return props.$panelPosition === 'right' && (0, _ykbStyledComponents.css)(["&-body{padding-left:16px !important;}"]);
});
var StyledPickerPanelContainer = exports.StyledPickerPanelContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-16bggdk-5"
})(["display:inline-block;overflow:hidden;vertical-align:top;background:", ";box-shadow:", ";transition:margin ", ";border:1px solid ", ";", "{display:inline-flex;flex-wrap:nowrap;direction:ltr;}", "{vertical-align:top;background:transparent;border-width:0 0 ", " 0;border-radius:0;", "}&-footer{border-top:", " ", " ", ";&-extra{padding:0 ", ";line-height:38px;text-align:left;&:not(:last-child){border-bottom:", " ", " ", ";}}}"], function (props) {
  return props.theme.datepicker.calendarBg;
}, function (props) {
  return props.theme.shadow.base;
}, function (props) {
  return props.theme.animation.slow.duration;
}, function (props) {
  return props.theme.colorPalette.grey6;
}, StyledPickerPanels, StyledPickerPanelWrapper, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.$focused && (0, _ykbStyledComponents.css)(["border-color:", ";"], function (props) {
    return props.theme.datepicker.borderColorSplit;
  });
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.style;
}, function (props) {
  return props.theme.datepicker.borderColor;
}, function (props) {
  return props.theme.datepicker.padding.sm;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.style;
}, function (props) {
  return props.theme.datepicker.borderColor;
});
var StyledPickerFooter = exports.StyledPickerFooter = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-16bggdk-6"
})([""]);
var StyledRangePickerRangeArrow = exports.StyledRangePickerRangeArrow = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-16bggdk-7"
})(["position:absolute;z-index:1;display:none;width:", ";height:", ";margin-left:calc( ", " * 1.5 );box-shadow:2px -2px 6px fade(#000,6%);transition:left ", "s ease-out;&::after{position:absolute;top:", ";right:", ";width:", ";height:", ";border:calc(", " / 2) solid ", ";border-color:", " ", " transparent transparent;content:'';}"], function (props) {
  return props.theme.datepicker.arrowSize;
}, function (props) {
  return props.theme.datepicker.arrowSize;
}, function (props) {
  return props.theme.input.sizes.medium.paddingHorizontal;
}, function (props) {
  return props.theme.animation.slow.duration;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.datepicker.arrowSize;
}, function (props) {
  return props.theme.datepicker.arrowSize;
}, function (props) {
  return props.theme.datepicker.arrowSize;
}, function (props) {
  return props.theme.datepicker.borderColorSplit;
}, function (props) {
  return props.theme.datepicker.calendarBg;
}, function (props) {
  return props.theme.datepicker.calendarBg;
});
var StyledClearIcon = exports.StyledClearIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-16bggdk-8"
})(["svg{font-size:", "px;}"], function (props) {
  return props.theme.datepicker.clear.iconSize;
});
var StyledCalendarIcon = exports.StyledCalendarIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-16bggdk-9"
})([""]);
var StyledCustomIcon = exports.StyledCustomIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-16bggdk-10"
})([""]);
var StyledTimeIcon = exports.StyledTimeIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-16bggdk-11"
})([""]);
var StyledSwapIcon = exports.StyledSwapIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-16bggdk-12"
})(["color:", ";"], function (props) {
  return props.$theme.colorPalette.grey6;
});
var StyledRangePickerActiveBar = exports.StyledRangePickerActiveBar = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-16bggdk-13"
})(["bottom:-", ";height:2px;background:", ";opacity:0;transition:all ", "s ease-out;pointer-events:none;"], function (props) {
  return props.theme.border.width;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.animation.slow.duration;
});
var pickerPaddingMixin = function pickerPaddingMixin(inputHeight, fontSize, paddingHorizontal, lineHeightBase) {
  fontSize = replacePx(fontSize);
  inputHeight = replacePx(inputHeight);
  lineHeightBase = replacePx(lineHeightBase);
  var fontHeight = Math.floor(fontSize * lineHeightBase) + 2;
  var paddingTop = Math.max((inputHeight - fontHeight) / 2, 0);
  var paddingBottom = Math.max(inputHeight - fontHeight - paddingTop, 0);
  return (0, _ykbStyledComponents.css)(["padding:", "px ", " ", "px;"], paddingTop, paddingHorizontal, paddingBottom);
};
var StyledDatePickerInput = exports.StyledDatePickerInput = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-16bggdk-14"
})(["position:relative;display:inline-flex;width:100%;", "{flex:auto;min-width:1px;height:auto;border:0;", " &:focus{box-shadow:none;}&[disabled]{background:transparent;background-color:", ";color:", ";border-radius:8px 0 0 8px;&:hover{border-color:", ";}+ span{background-color:", ";border-radius:0 8px 8px 0;}}", "}"], _StyledTextInput.StyledInput, function (props) {
  return props.$endInput && (0, _ykbStyledComponents.css)(["padding-left:0px;"]);
}, function (props) {
  return props.theme.input.disabled.backgroundColor;
}, function (props) {
  return props.theme.input.disabled.color;
}, function (props) {
  return props.theme.datepicker.borderColor;
}, function (props) {
  return props.theme.input.disabled.backgroundColor;
}, function (props) {
  return props.$backgroundColorType && (0, _ykbStyledComponents.css)(["background-color:", ";+ span{background-color:", ";}"], props.$backgroundColorType === 'danger' ? props.theme.color.danger1 : props.theme.color.neutral1, props.$backgroundColorType === 'danger' ? props.theme.color.danger1 : props.theme.color.neutral1);
});
var StyledRangePickerWrapper = exports.StyledRangePickerWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-16bggdk-15"
})(["display:flex;"]);
var Container = function Container(_ref3) {
  var children = _ref3.children,
    theme = _ref3.theme,
    className = _ref3.className;
  var prefix = className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledDatePickerBase, {
    theme: theme,
    prefixCls: prefix
  }), children(prefix));
};
var pickerBase = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-16bggdk-16"
})(["", ";", ";padding:0px;position:relative;display:inline-flex;align-items:center;background:", ";border:", " ", " ", ";border-radius:", ";transition:border ", ",box-shadow ", ";width:100%;&:hover{", "}", " ", " ", " ", "{min-width:unset;display:flex;", "{border:unset;height:38px;padding-right:10px;&:focus{box-shadow:none;}", " ", "}", "{position:static;transform:none;width:40px;display:flex;align-items:center;justify-content:center;border-radius:4px;", "{color:", ";&:hover{cursor:pointer;}}", "}}", " ", " &-dropdown-range{padding:calc(", " * 2 / 3) 0;&-hidden{display:none;}}"], function (props) {
  return props.theme.mixins.resetComponent(_ykbStyledComponents.css);
}, function (_ref4) {
  var theme = _ref4.theme;
  return pickerPaddingMixin(theme.input.sizes.medium.height, theme.font.size, theme.input.sizes.medium.paddingHorizontal, theme.input.sizes.medium.lineHeight);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.datepicker.calendarBg;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.border.width;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.border.style;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.datepicker.borderColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.borderRadiusBase;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.animation.slow.duration;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.animation.slow.duration;
}, function (props) {
  return !props.$disabled && (0, _ykbStyledComponents.css)(["border-color:", ";"], function (_ref12) {
    var theme = _ref12.theme;
    return theme.color.primary6;
  });
}, function (props) {
  return props.$focused && (0, _ykbStyledComponents.css)(["border-color:", ";outline:0;box-shadow:", ";border-right-width:1px !important;"], function (props) {
    return props.theme.color.primary6;
  }, function (props) {
    return props.theme.datepicker.focusBoxShadow;
  });
}, function (props) {
  return props.$disabled && (0, _ykbStyledComponents.css)(["cursor:not-allowed;", "{color:", ";}"], StyledPickerSuffix, function (props) {
    return props.theme.colorPalette.grey6;
  });
}, function (props) {
  return props.$borderless && (0, _ykbStyledComponents.css)(["background-color:transparent !important;border-color:transparent !important;box-shadow:none !important;"]);
}, _StyledTextInput.StyledInputWrapper, _StyledTextInput.StyledInput, function (props) {
  return props.$size === 'small' && (0, _ykbStyledComponents.css)(["height:28px;"]);
}, function (props) {
  return props.$size === 'large' && (0, _ykbStyledComponents.css)(["height:48px;"]);
}, _StyledTextInput.StyledInputSuffix, StyledClearIcon, function (props) {
  return props.theme.colorPalette.grey6;
}, function (props) {
  return props.$size === 'small' && (0, _ykbStyledComponents.css)(["right:4px;"]);
}, function (props) {
  return props.$size === 'large' && (0, _ykbStyledComponents.css)(["", "{", "{font-size:", ";}}"], StyledDatePickerInput, _StyledTextInput.StyledInput, function (_ref13) {
    var theme = _ref13.theme;
    return theme.font.sizeLg;
  });
}, function (props) {
  return props.$range && (0, _ykbStyledComponents.css)(["position:relative;display:inline-flex;", ""], function (props) {
    return props.$focused && (0, _ykbStyledComponents.css)(["", "{opacity:1;}"], StyledRangePickerActiveBar);
  });
}, function (props) {
  return props.theme.datepicker.arrowSize;
});
var StyledDatePicker = exports.StyledDatePicker = (0, _ykbStyledComponents.default)(pickerBase).withConfig({
  componentId: "ykb-ui__sc-16bggdk-17"
})([""]);
var StyledRangePicker = exports.StyledRangePicker = (0, _ykbStyledComponents.default)(pickerBase).withConfig({
  componentId: "ykb-ui__sc-16bggdk-18"
})(["display:flex;position:relative;", ""], function (props) {
  return props.$focused && (0, _ykbStyledComponents.css)(["", "{opacity:1;}"], StyledRangePickerActiveBar);
});